(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(pointer: fine)');
  const savedKey = 'techaura-saved-products';
  const readSaved = () => {
    try { const items = JSON.parse(localStorage.getItem(savedKey) || '[]');
      return Array.isArray(items) ? items.filter(item => typeof item.id === 'string' && typeof item.title === 'string' && /^\/products\/[^/]+$/.test(item.url)).slice(0,100) : [];
    } catch (_) { return []; }
  };
  const boot = (root = document) => {
    root.querySelectorAll('[data-save-product]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const sync = () => {const saved = readSaved().some(item => item.id === button.dataset.id);button.setAttribute('aria-pressed',String(saved));button.textContent = saved ? button.dataset.savedLabel : button.dataset.saveLabel;};
      sync();
      button.addEventListener('click', () => {
        const items = readSaved();const exists = items.some(item => item.id === button.dataset.id);
        try {localStorage.setItem(savedKey, JSON.stringify(exists ? items.filter(item => item.id !== button.dataset.id) : [...items,{id:button.dataset.id,title:button.dataset.title,url:button.dataset.url,image:button.dataset.image}].slice(-100)));sync();} catch (_) {button.disabled = true;}
      });
    });
    root.querySelectorAll('[data-wishlist]').forEach(list => {
      if (list.dataset.ready) return;
      list.dataset.ready = 'true';
      const render = () => {
        list.replaceChildren();const items = readSaved();
        if (!items.length) {const empty = document.createElement('p');empty.textContent = list.dataset.empty;list.append(empty);return;}
        items.forEach(item => {
          const card = document.createElement('article');card.className = 'ta-product-card';
          const media = document.createElement('a');media.className = 'ta-product-card__media';media.href = item.url;
          if (typeof item.image === 'string' && /^(https:\/\/techauraonline\.com\/cdn\/|\/cdn\/|\/\/techauraonline\.com\/cdn\/)/.test(item.image)) {const image = document.createElement('img');image.src = item.image;image.alt = item.title;image.loading = 'lazy';media.append(image);}
          const body = document.createElement('div');body.className = 'ta-product-card__body';
          const heading = document.createElement('h3');const link = document.createElement('a');link.href = item.url;link.textContent = item.title;heading.append(link);
          const remove = document.createElement('button');remove.type = 'button';remove.className = 'ta-text-button';remove.textContent = list.dataset.remove;
          remove.addEventListener('click',()=>{try {localStorage.setItem(savedKey,JSON.stringify(readSaved().filter(saved=>saved.id!==item.id)));render();} catch (_) {remove.disabled = true;}});
          body.append(heading,remove);card.append(media,body);list.append(card);
        });
      };render();
    });

    root.querySelectorAll('[data-ta-reveal]').forEach(el => {
      if (el.dataset.revealReady || reducedMotion.matches || !('IntersectionObserver' in window)) return;
      el.dataset.revealReady = 'true';
      el.classList.add('ta-reveal-pending');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('ta-visible'); observer.unobserve(entry.target); }
        });
      }, {threshold: 0.05});
      observer.observe(el);
    });
    root.querySelectorAll('[data-ta-tilt]').forEach(el => {
      if (el.dataset.tiltReady) return;
      el.dataset.tiltReady = 'true';
      let frame;
      el.addEventListener('pointermove', event => {
        if (reducedMotion.matches || !finePointer.matches || document.body.classList.contains('ta-motion-paused')) return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const rect = el.getBoundingClientRect();
          el.style.setProperty('--rx', `${-(event.clientY - rect.top - rect.height / 2) / rect.height * 5}deg`);
          el.style.setProperty('--ry', `${(event.clientX - rect.left - rect.width / 2) / rect.width * 7}deg`);
        });
      }, {passive:true});
      el.addEventListener('pointerleave', () => {cancelAnimationFrame(frame);el.style.removeProperty('--rx');el.style.removeProperty('--ry');});
    });
    root.querySelectorAll('[data-ta-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      hero.querySelectorAll('[data-hero-tab]').forEach(button => {
        button.addEventListener('click', () => {
          hero.querySelectorAll('[data-hero-panel]').forEach(panel => {panel.hidden = panel.dataset.heroPanel !== button.dataset.heroTab;});
          hero.querySelectorAll('[data-hero-tab]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
        });
      });
    });
    root.querySelectorAll('[data-motion-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const sync = () => {
        const paused = document.body.classList.contains('ta-motion-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      };
      button.addEventListener('click', () => {
        document.body.classList.toggle('ta-motion-paused');
        try { localStorage.setItem('techaura-motion-paused', String(document.body.classList.contains('ta-motion-paused'))); } catch (_) {}
        sync();
      });
      sync();
    });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const showMedia = id => {
        const target = Array.from(section.querySelectorAll('[data-product-media]')).find(el => el.dataset.productMedia === String(id));
        if (!target) return;
        section.querySelectorAll('[data-product-media]').forEach(el => {
          el.hidden = el !== target;
          if (el.hidden) el.querySelectorAll('video').forEach(video => video.pause());
        });
        section.querySelectorAll('[data-media-button]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaButton === String(id))));
      };
      section.querySelectorAll('[data-media-button]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaButton)));
      const select = section.querySelector('[data-variant-select]');
      const add = section.querySelector('[data-add-button]');
      const status = section.querySelector('[data-cart-status]');
      const bagLink = section.querySelector('[data-view-bag]');
      const form = section.querySelector('[data-product-form]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelector('[data-variant-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-variant-compare]');
        compare.textContent = option.dataset.compare || '';compare.hidden = !option.dataset.compare;
        add.disabled = !available;add.textContent = available ? add.dataset.addLabel + ' ↗' : add.dataset.soldLabel;
        const stock = section.querySelector('[data-variant-stock]');
        stock.textContent = available ? stock.dataset.availableLabel : add.dataset.soldLabel;
        const quantity = form.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1';quantity.step = option.dataset.step || '1';quantity.value = quantity.min;
        if (option.dataset.max) quantity.max = option.dataset.max;else quantity.removeAttribute('max');
        showMedia(option.dataset.media);
        const url = new URL(window.location.href);url.searchParams.set('variant', option.value);history.replaceState(null, '', url);
        status.textContent = '';bagLink.hidden = true;
      });
      if (form && window.fetch) form.addEventListener('submit', async event => {
        event.preventDefault();
        if (add.disabled) return;
        add.disabled = true;add.setAttribute('aria-busy','true');status.textContent = '';bagLink.hidden = true;
        const payload = new FormData(form);
        if (!payload.get('selling_plan')) payload.delete('selling_plan');
        try {
          const response = await fetch(form.action.replace(/\/$/,'') + '.js', {method:'POST',body:payload,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || status.dataset.error);
          status.textContent = status.dataset.success;bagLink.hidden = false;
          try {
            const cartResponse = await fetch(section.dataset.cartUrl.replace(/\/$/,'') + '.js', {headers:{Accept:'application/json'}});
            if (cartResponse.ok) {const cart = await cartResponse.json();document.querySelectorAll('.ta-cart-count').forEach(el => {el.textContent = cart.item_count;});}
          } catch (_) { /* The item was added; a badge refresh failure must not report otherwise. */ }
        } catch (error) {status.textContent = error.message || status.dataset.error;}
        finally {add.disabled = select.selectedOptions[0].dataset.available !== 'true';add.removeAttribute('aria-busy');}
      });
    });
    root.querySelectorAll('[data-country-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const match = Array.from(select.options).find(o => o.value === select.dataset.default || o.textContent === select.dataset.default);
      if (match) select.value = match.value;
      const province = document.getElementById(select.dataset.provinceTarget);
      const update = () => {
        let provinces = [];
        try {provinces = JSON.parse(select.selectedOptions[0]?.dataset.provinces || '[]');} catch (_) {}
        province.replaceChildren();
        provinces.forEach(([value,label]) => {const option = document.createElement('option');option.value = value;option.textContent = label;option.selected = value === province.dataset.default || label === province.dataset.default;province.append(option);});
        province.closest('[data-province-wrapper]').hidden = !provinces.length;province.disabled = !provinces.length;
      };
      select.addEventListener('change', update);update();
    });
  };
  try {if(localStorage.getItem('techaura-motion-paused') === 'true') document.body.classList.add('ta-motion-paused');} catch (_) {}
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('ta-page-hidden', document.hidden));
  document.addEventListener('keydown', event => {if(event.key === 'Escape') document.querySelectorAll('.ta-mobile-menu[open]').forEach(el => {el.open = false;el.querySelector('summary').focus();});});
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
